// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import VueResource from 'vue-resource'
import VueCookies from 'vue-cookies'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './style.css'

import BackendService from '@/services/BackendService'

import * as moment from 'moment'
import * as vueMoment from 'vue-moment'
import 'moment/locale/fr'

Vue.config.productionTip = false

/* bootstrap */
Vue.use(VueResource)
Vue.http.options.credentials = true;

Vue.use(BootstrapVue)

/* momentjs */

Vue.use(vueMoment, {
  moment,
})

Vue.moment().locale('fr')

Vue.use(VueCookies)

/* configure backend service as a plugin */
var backendPlugin = {
  install: function (Vue) {
    Vue.$backend = new BackendService()
    Vue.$custom = {
      urlFormat: function(string) {
        return string.replace(/ /g, '-')
      },
      dlCsv: function(text, fileName){
        var blob = new Blob([text], { type: 'text/csv' });
      
        var a = document.createElement('a');
        a.download = fileName;
        a.href = URL.createObjectURL(blob);
        a.dataset.downloadurl = ['text/csv', a.download, a.href].join(':');
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(function() { URL.revokeObjectURL(a.href); }, 1500);
        
      }
    }

    Vue.$isConnected =  function() {
      return window.$cookies.get('role')
    }

    Vue.$getUserEmail =  function() {
      return window.$cookies.get('username')
    }

    Vue.$isAdmin =  function() {
      const role = window.$cookies.get('role')
      return role === "admin"
    }

    Vue.$isUser =  function() {
      const role = window.$cookies.get('role')
      return role === "user"
    }

    Vue.$tinykey = "ubzf8nzdvnfaztm4vww6l6idfp3t4q0jj37bgwhq8dnme2oe";
  },
}
Vue.use(backendPlugin)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
}).$mount('#app')
